import * as React from 'react';
import {PureComponent} from 'react';
import {dataControlStyle} from "./dataControlStyle";

export default class LayersIcon extends PureComponent <any, any> {
    render() {
        return (
            <svg viewBox="0 0 200 200" style={{...dataControlStyle}}>
                <polyline points="121.9,128.1 121.9,137 45.6,137 45.6,82.2 55.4,82.2 "/>
                <path d="M137.1,107.1"/>
                <polyline points="131.8,117.8 131.8,128.1 55.4,128.1 55.4,73.3 67.3,73.3 "/>
                <rect x="78" y="52.2" transform="matrix(6.123234e-17 -1 1 6.123234e-17 15.0243 195.8461)" width="54.8" height="76.3"/>
            </svg>
        );
    }
}